import { TextLinkWidget } from '@tableau/widgets';
import { LoginUrlsWrapper } from '~src/app/spaces/Login/LoginUrls';
import { Messages } from '~src/codegen/Localize';
import { IError } from '~src/httpClient/serverApi/types/IError';
import { ServerSettingsUnauthenticated } from '~src/settings/services/ServerSettingsUnauthenticated';
import { FeatureFlags } from '~src/ts/FeatureFlags';
import { UserErrorCode } from '~src/ts/helpers/ErrorCodes';
import { LocalUsernameAndPasswordRateLimiting } from '../LocalUsernameAndPasswordRateLimiting';
import { LoginPage } from './LoginPage';
import { UsernameAndPasswordLoginProps } from './UsernameAndPasswordLogin';
import { UsernameAndPasswordLoginForm } from './UsernameAndPasswordLoginForm';
import React = require('react');


export function LocalUsernameAndPasswordLogin(props: UsernameAndPasswordLoginProps) {

  const [rateLimitingHandler, setRateLimitingHandler] = React.useState(() => ((error: IError, username: string) => Promise.resolve()));

  function handleLocalAuthErrors(error: IError, username: string): Promise<void> {
    if (FeatureFlags.localAuthPasswordExpirationEnabled && error.code === UserErrorCode.UserMustResetPassword) {
      LoginUrlsWrapper.navigateToPasswordResetWithUsername(username);
      // We take control and navigate away, instead of sticking with the login form.
      return Promise.reject();
    }

    return rateLimitingHandler(error, username);
  }

  const isPasswordResetEnabled = ServerSettingsUnauthenticated.isPasswordResetEnabled() ||
    ServerSettingsUnauthenticated.preloginCustomization()?.resetPasswordUrl;
  const wasPasswordResetSuccessful = isPasswordResetEnabled && props.signinQueryParams.passwordResetSuccess;
  const resetPasswordUrl = ServerSettingsUnauthenticated.preloginCustomization()?.resetPasswordUrl ??
    LoginUrlsWrapper.getInstance().requestPasswordResetUrl();
  // TFSID:1313358 - wrap handler to avoid infinite loop in desktop 2020.4 and earlier (webkit issue)
  const handleRateLimiting = React.useCallback((handler) => setRateLimitingHandler(() => handler), []);

  return <LoginPage>

    {wasPasswordResetSuccessful &&
      <div className='tb-password-reset-success-header'>
        {Messages.updatePasswordSuccess()}
      </div>
    }

    <UsernameAndPasswordLoginForm {...props} onError={handleLocalAuthErrors} />

    <LocalUsernameAndPasswordRateLimiting populateHandler={handleRateLimiting} />

    {isPasswordResetEnabled &&
      <TextLinkWidget
        testId='forgot-password-link'
        tb-test-id='forgot-password-link' // Maintaining legacy test id to be backwards compatible for existing test automation.
        href={resetPasswordUrl}
        className='tb-login-forgot-password'>
        {wasPasswordResetSuccessful ? Messages.forgotYourPasswordAgain() : Messages.forgotYourPassword()}
      </TextLinkWidget>
    }

  </LoginPage>;
}
